export default __webpack_public_path__ + "static/media/open_page.166ccafb.mp3";